import {
  ChevronsLeft,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
} from 'react-feather';
import './style.css'

interface iPaginationContainer {
  page: number;
  lastPage: number;
  setPage: CallableFunction;
}

export default function PaginationContainer({
  page,
  lastPage,
  setPage,
}: iPaginationContainer) {
  return (
    <div className="paginationContainer">
      <div>Pagination</div>
      <div className="arrows">
        <ChevronsLeft
          className="paginationArrow"
          size={26}
          onClick={() => setPage(1)}
        />
        <ChevronLeft
          className="paginationArrow"
          size={26}
          onClick={() => (page === 1 ? setPage(1) : setPage((page -= 1)))}
        />
        <div className="paginationArrow">1 - {page} - {lastPage}</div>
        <ChevronRight
          className="paginationArrow"
          size={26}
          onClick={() => setPage((page += 1))}
        />
        <ChevronsRight
          className="paginationArrow"
          size={26}
          onClick={() => setPage(lastPage)}
        />
      </div>
    </div>
  );
}
